import { render, staticRenderFns } from "./PrivacySettings.vue?vue&type=template&id=36a81a52&scoped=true&"
import script from "./PrivacySettings.vue?vue&type=script&lang=js&"
export * from "./PrivacySettings.vue?vue&type=script&lang=js&"
import style0 from "./PrivacySettings.vue?vue&type=style&index=0&id=36a81a52&lang=scss&scoped=true&"
import style1 from "./PrivacySettings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a81a52",
  null
  
)

export default component.exports